import { Component } from '@angular/core';
import { Config, Platform } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { GoogleAnalytics } from '@ionic-native/google-analytics';

//import { TabsPage } from '../pages/tabs/tabs';
//import { LoginPage } from '../pages/login/login';

import { User } from '../providers/user';


@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  rootPage:any = null;

  constructor(platform: Platform, statusBar: StatusBar, splashScreen: SplashScreen, user: User, public config: Config,private ga: GoogleAnalytics) {
    let globalActions = function() {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      statusBar.styleDefault();
      splashScreen.hide();
    };

    let hash = location.hash;
    let deepLink:any;
    // capitalizes the first letter of the page name
    if (hash.indexOf("viewer") > -1)
    {
        //deepLink = hash.charAt(2).toUpperCase() + hash.slice(3);
        deepLink = 'viewer';
    }
    platform.ready().then(() => {
      user.isAuthenticated().then(() => {
        console.log('you are authenticated!');
        //this.rootPage = TabsPage;
        if(hash.length <= 0){
          this.rootPage = 'TabsPage';
        }
        //this.rootPage = deepLink || 'TabsPage';
        //this.rootPage = 'HomePage';
        //this.rootPage = HomePage;
        
        //TODO googla analytics for broser comment for app deply
        //(<any>window).ga('set', 'page', location.href);
        //(<any>window).ga('send', 'pageview');

        //TODO uncomment for app deploy
        //Below for cordova only works on app not browser
        /*
        this.ga.startTrackerWithId('UA-114228129-2')
        .then(() => {
          console.log('Google analytics is ready now');
          //the component is ready and you can call any method here
          this.ga.debugMode();
          this.ga.setAllowIDFACollection(true);
        })
        .catch(e => console.log('Error starting GoogleAnalytics', e));
        */
        globalActions();
      }).catch(() => {
        console.log('you are not authenticated..'); 
        //this.rootPage = LoginPage;
        this.rootPage = deepLink || 'LoginPage';
        globalActions();
      });
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts